module.exports = __webpack_public_path__ + "static/img/arachas3.68eb9e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/arachas3.png
// module id = w3Im
// module chunks = 0